import { Component, input } from '@angular/core';
import { PipesModule } from '@app/shared/pipes/pipes.module';
import { NgIf } from '@angular/common';

export type HtmlContentAppearance = 'plain' | 'instructions';

@Component({
  selector: 'ti-html-content',
  standalone: true,
  imports: [PipesModule, NgIf],
  templateUrl: './html-content.component.html',
  styleUrl: './html-content.component.scss',
})
export class HtmlContentComponent {
  public appearance = input<HtmlContentAppearance>('plain');
  public content = input<string>(null);
}
